export const getCallState = (state) => state.call;
